module.exports = __webpack_public_path__ + "img/IE.dea50c27.svg";